import { useMemo } from 'react';

import { BreadcrumbWrapper, Crumb } from '@/components/Breadcrumbs/BreadcrumbWrapper';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { getAuctioneerDirectoryUrl, getSellerUrl } from '@/utils/urls';

export interface RatingsPageBreadcrumbsProps {
    sellerId: number;
    sellerName: string;
}

export const RatingsPageBreadcrumbs = ({ sellerId, sellerName }: RatingsPageBreadcrumbsProps) => {
    const formatMessage = useAppFormatMessage();

    const crumbs = useMemo(() => {
        const crumbs: Crumb[] = [
            {
                label: formatMessage(['online_auctions']),
                link: '/',
            },
            {
                label: formatMessage(['auction_house_directory']),
                link: getAuctioneerDirectoryUrl(),
            },
        ];
        if (sellerName) {
            crumbs.push({
                label: sellerName,
                link: getSellerUrl(sellerId, sellerName),
            });
            crumbs.push({
                label: formatMessage(['review', 'all_reviews']),
            });
        }
        return crumbs;
    }, [formatMessage, sellerId, sellerName]);

    return (
        <BreadcrumbWrapper
            className="mt-lg"
            crumbs={crumbs}
        />
    );
};
